import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
//import { Response } from "@angular/http"
import { Observable } from 'rxjs';
import { User } from '../../model/user.model';
import { BehaviorSubject } from 'rxjs';
import { ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { distinctUntilChanged } from 'rxjs/operators';
import { JwtService } from '../../auth/jwt.service';
import { DataSharingService } from '../../auth/data-sharing.service';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EvaluationService {

  currentUserData: any;
  vendorData : any;
  enlistmentStepsData : any;
  enlistmentStepsSorted : any = [];


  //readonly rootUrl = "";
  readonly rootUrl = environment.baseUrl;

  constructor(private http: HttpClient, private jwtService: JwtService,
    private dataSharingService: DataSharingService) { }


    getVendorsForEvaluation()
    {
      return this.http.get(this.rootUrl + '/api/Evaluation/getVendorsForEvaluation');
    }

    getAllVendorsForEvaluation()
    {
      return this.http.get(this.rootUrl + '/api/Evaluation/getAllVendorsForEvaluation');
    }

    getAllVendorsForEvaluationForProjectId()
    {
      return this.http.get(this.rootUrl + '/api/Evaluation/getAllVendorsForEvaluationForProjectId');
    }


    getEvaluatedVendors()
    {
      return this.http.get(this.rootUrl + '/api/Evaluation/getEvaluatedVendors');

    }

    getVendorData(applicationRef)
    {
      var data = {
        applicationNumber : applicationRef
      }
      return this.http.post(this.rootUrl + '/api/Evaluation/getVendorData', data);

    }

    getVendorDataForScoreObservation(applicationRef)
    {
      var data = {
        applicationNumber : applicationRef
      }
      return this.http.post(this.rootUrl + '/api/Evaluation/getVendorDataForScoreObservation', data);

    }

    saveEvaluationScoreData(form)
    {
      return this.http.post(this.rootUrl + '/api/Evaluation/saveEvaluationScoreData', form);
    }

}
